import ProjectService from '@/services/requests/projectService'
import Store from '@/store/computed/storeHelpers'
export default {
  methods: {
    getProjects() {
      this.loadingProjects = true
      return ProjectService.getAllProjects()
        .then(result => {
          this.loadingProjects = false
          this.projects = result.data.result
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          this.loadingProjects = false
          this.snackError()
        })
    }
  },
  computed: {
    loadingProjects: Store.getSet({
      store: 'projects',
      prop: 'loadingProjects'
    }),
    projects: Store.getSet({ store: 'projects', prop: 'projects' })
  },
  mounted() {
    if (!this.projects.length && this.$route.name !== 'audit') {
      this.getProjects()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.projects = []
  }
}
